
// Organization Action type
export const SET_THEME = 'UI_SET_THEME';
export const DASHBOARD_INCIDENT_MODAL_TOGGLE = 'DASHBOARD_INCIDENT_MODAL_TOGGLE';
export const SET_INCIDENT_MODAL_STATE = 'SET_INCIDENT_MODAL_STATE';
export const SET_SIDEBAR_COLLAPSED = 'SET_SIDEBAR_COLLAPSED';
export const SET_RECENT_INCIDENTS_HISTORY = 'SET_RECENT_INCIDENT_HISTORY';
export const LOGOUT_MODAL_TOGGLE = 'LOGOUT_MODAL_TOGGLE';
export const DASHBOARD_NAME = 'DASHBOARD_NAME';
export const SET_MEET_MODE = 'SET_MEET_MODE';
export const SET_INCIDENTS_DATAS = 'SET_INCIDENTS_DATAS';
